import { ModelText } from '@cadstrom/cadstrom-shared';

import type { ModulePinoutRow } from './get-module-pinout-rows.js';

/**
 * Returns every searchable spelling in a pinout row while retaining raw identifiers for identity.
 *
 * @param row - Pinout row to search.
 * @param dialects - Text conventions permitted for the row's model provenance.
 * @returns Raw and display spellings together with the row's other filter fields.
 */
export function getModulePinoutRowSearchHaystack(row: ModulePinoutRow, dialects: ModelText.TextDialect[]): string[] {
	return [
		row.pinNumber,
		...(row.signal ? ModelText.searchHaystack({ raw: row.signal.name, dialects }) : []),
		row.type ?? '',
		row.direction ?? '',
		...(row.net ? ModelText.searchHaystack({ raw: row.net, dialects }) : []),
	];
}
